import * as tslib_1 from "tslib";
import { BitmapFilter } from "./BitmapFilter";
var GradientBevelFilter = (function (_super) {
    tslib_1.__extends(GradientBevelFilter, _super);
    function GradientBevelFilter(distance, angle, colors, alphas, ratios, blurX, blurY, strength, quality, type, knockout) {
        return _super.call(this) || this;
    }
    GradientBevelFilter.prototype.clone = function () {
        console.log("clone not implemented yet in flash/GradientBevelFilter");
        return null;
    };
    return GradientBevelFilter;
}(BitmapFilter));
export { GradientBevelFilter };
